
import React from 'react';
import type { BrandConfig } from '../types/index.js';
import { BrandContext } from './BrandContext.js';

interface BrandProviderProps {
  config: BrandConfig;
  children: React.ReactNode;
}

/**
 * Provides brand configuration to the entire component tree.
 * Wrap your app root with this component.
 *
 * @example
 *   <BrandProvider config={acoBrandConfig}>
 *     <App />
 *   </BrandProvider>
 */
export function BrandProvider({ config, children }: BrandProviderProps) {
  return <BrandContext.Provider value={config}>{children}</BrandContext.Provider>;
}
